import { CustomFieldListItemProps } from "@/components/custom-field/list-item/custom-field-list-item.type.ts";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { ListItem } from "@skailer-com/uikit";

export function CustomFieldListItemDate({ field, fieldValue, label }: CustomFieldListItemProps) {
  const { renderDate } = useFormatter();
  const title = fieldValue?.date_value ? renderDate(fieldValue?.date_value) : "-";
  return <ListItem preTitle={label ?? field.title} title={title} />;
}
